<div class="box-body row">
  <div class="col-sm-12">
    <div class="col text-center">
      <button class="btn btn-primary" id="btnSearchDetail" (click)="onSearch()">
        <span><i class="fa fa-search"></i></span>
        <b>&nbsp;Search</b>
      </button>
      <button class="btn btn-primary" id="btnSearchDetailHide" (click)="onCancel()" style="margin-left: 6px;">
        <span><i class="fa fa-times"></i></span>
        <b>&nbsp;Cancel</b>
      </button>
    </div>
  </div>
</div>